module.exports = __webpack_public_path__ + "static/media/familia.c7ee2d9f.png";